module.exports = __webpack_public_path__ + "img/interloper.4f830a2a.jpg";